<template>
	<div class="small-12 emailSignUp">
		<form class="small-12 float-left userRegistration" v-on:submit.prevent="onSubmit">
			<fieldset class="small-12 large-6 columns">
				<label>First Name</label>
				<input type="text" name="first_name" v-model="new_user.attributes.profile.first_name" required>
			</fieldset>
			<fieldset class="small-12 large-6 columns">
				<label>Last Name</label>
				<input type="text" name="last_name" v-model="new_user.attributes.profile.last_name" required>
			</fieldset>
			<fieldset class="small-12 columns">
				<label>Email</label>
				<input type="email" name="email" v-model="new_user.attributes.profile.email" required>
			</fieldset>
			<fieldset class="small-12 columns">
				<label>Password</label>
				<input type="password" name="password" placeholder="6+ characters" v-model="password" required>
			</fieldset>
			<fieldset class="small-12 columns termsAgreement">
				<input type="checkbox" name="agree_to_terms" id="agree_to_terms" v-model="new_user.attributes.terms_agreement.opted_in">
				<label for="agree_to_terms">
					Creating an account means you agree with our 
					<a class="terms">
						Terms of Service
					</a>,
					<a class="privacy">
						Privacy Policy
					</a> 
					and our default 
					<a class="notifications">
						Notification Settings
					</a>.
				</label>
			</fieldset>
			<div class="small-12 columns action flex vertical-align">
				<a class="primaryButton borderRadius50 flex justify-center" @click="emailSignUp()">
					Create Account
				</a>
				<p class="auto">
					Already a member? 
					<router-link :to="{ name: 'SignIn' }">
						Sign In
					</router-link>
				</p>
			</div>
		</form>
	</div>
</template>

<script>

	// Import firebase services
    import { firebaseAuth } from '@/firebase/firebase-config'

    // Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { UsersRepository } from '@/components/mixins/repositories/users/UsersRepository'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { GenerateUID } from '@/mixins/helpers/GenerateUID'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'EmailSignUp',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			UsersRepository,
			SpinnerMethods,
			GenerateUID

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			password: null,
			character_count: 6

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			onSubmit: function() {

				// Do nothing

			},

			validate: function() {

				if (!this.new_user.attributes.profile.first_name) return 'A first name is required.';
				if (!this.new_user.attributes.profile.last_name) return 'A last name is required.';
				if (!this.new_user.attributes.profile.email) return 'An email address is required.';
				if (!this.password) return 'A password is required.';
				if (!this.new_user.attributes.terms_agreement.opted_in) return 'You must agree with our terms and conditions.';
				if (!this.validateEmailFormat()) return 'Looks like you have entered a bad email address.';
				if (this.validateCharacterCount()) return 'Your password must be 6 or more characters in length.';

			},

			validateEmailFormat: function() {

				// Set the regex
				let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

				// Test the email
				if (emailFormat.test(this.new_user.attributes.profile.email)) return true;

				return false;

			},

			validateCharacterCount: function() {

				// Count the characters
				if (this.password.length < this.character_count) return true;

			},

			slugifyTheSlug: function() {

				// Set the slug - slugify - main.js
				this.new_user.attributes.profile.slug = slugify(this.slugifiedSlug, {
					replacement: '_',
					remove: /[*+~.()'"!:@]/g,
					lower: true,
				});

				// Add slug as username
				this.new_user.attributes.profile.username = this.new_user.attributes.profile.slug;

				// Add UID to it to make unique
				this.new_user.attributes.profile.slug = this.new_user.attributes.profile.slug + '_' + this.generateUID();

			},

			emailSignUp: function() {

				// Validate the fields
				let validation = this.validate();

				// Return validation error
				if (validation) {

					// Throw error message
				    this.$swal('Uh Oh!', validation, 'error');

				    return;

				}

				// Show the spinner
    			this.showSpinner();

    			// Set the slug
				this.slugifyTheSlug();

				// Create the user in firestore
				firebaseAuth.createUserWithEmailAndPassword(this.new_user.attributes.profile.email, this.password)
				.then(credential => {

					// Set the user's name in firebase auth
					credential.user.updateProfile({

					    displayName: this.new_user.attributes.profile.first_name + ' ' + this.new_user.attributes.profile.last_name

					});

					// Create the user record
					this.createUserRecord(credential.user.uid);

				})
				.catch(error => {

					// Hide the spinner
					this.hideSpinner();

					// Throw warning message
	    			this.$swal('Uh Oh!', error.message, 'error');

	    			// Send to bugsnag
					this.reportNoAuthBugsnagError({
						title: 'SISU - Create User With Email and Password',
						errorType: 'Firebase Auth',
						section: 'SISU',
						component: 'SignUpForm',
						error: error
					});

				});

			},

			createUserRecord: function(uid) {

				// Set the uid
				this.new_user.id = uid;

				// Repo - create user
				this.createUser(uid);

			}

		},

		/*
		**  Set up the computed props
		*/

		computed: {

			slugifiedSlug: function() {

				return this.new_user.attributes.profile.first_name + ' ' + this.new_user.attributes.profile.last_name;

			}

		}

	}

</script>